var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`nb-spinner align-${_vm.align}`},[_c('NbIcon',{attrs:{"icon":"loader","attributes":{
      class: 'mr-1 mb-1 spin',
      width: _vm.size,
      height: _vm.size,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }